import { Link } from 'react-router-dom'
import { useEffect } from 'react'
import '../styles/MobileBackButton.css'

function MobileBackButton({ to = '/', label = 'Back to Home' }) {
  const handleClick = () => {
    // Scroll to top when navigating
    window.scrollTo(0, 0)
  }

  return (
    <div className="mobile-back-button-container">
      <Link 
        to={to} 
        className="mobile-back-button" 
        aria-label={label}
        onClick={handleClick}
      >
        <svg 
          width="24" 
          height="24" 
          viewBox="0 0 24 24" 
          fill="none" 
          xmlns="http://www.w3.org/2000/svg"
        >
          <path 
            d="M19 12H5M12 19L5 12L12 5" 
            stroke="currentColor" 
            strokeWidth="2" 
            strokeLinecap="round" 
            strokeLinejoin="round"
          />
        </svg>
        <span className="back-text">{label}</span>
      </Link>
    </div>
  )
}

export default MobileBackButton